<template>
  <div>
    <div class="pleaseWait flex flex-col">
      <p class="font-semibold dark:text-white">
        Please wait
      </p>
      <span><i /><i /><i /><i /><i /><i /></span>
    </div>
  </div>
</template>

<style scoped>
.pleaseWait {
    position: relative;
    left: 0;
    right: 0;
    top: 50%;
    width: 100px;
   
    margin: auto;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
}
.pleaseWait span {
    position: absolute;
    height: 10px;
    width: 84px;
    top: 20px;
    overflow: hidden;
}
.pleaseWait span > i {
    position: absolute;
    height: 4px;
    width: 4px;
    border-radius: 50%;
    -webkit-animation: wait 4s infinite;
    -moz-animation: wait 4s infinite;
    -o-animation: wait 4s infinite;
    animation: wait 4s infinite;
}
.pleaseWait span > i:nth-of-type(1) {
    left: -8px;
    background: #3a2246;
}
.pleaseWait span > i:nth-of-type(2) {
    left: -1px;
    -webkit-animation-delay: 0.8s;
    animation-delay: 0.8s;
    background: #F15B29;
}

@-webkit-keyframes wait {
    0%   { left: -7px  }
    30%  { left: 52px  }
    60%  { left: 22px  }
    100% { left: 100px }
}
@-moz-keyframes wait {
    0%   { left: -7px  }
    30%  { left: 52px  }
    60%  { left: 22px  }
    100% { left: 100px }
}
@-o-keyframes wait {
    0%   { left: -7px  }
    30%  { left: 52px  }
    60%  { left: 22px  }
    100% { left: 100px }
}
@keyframes wait {
    0%   { left: -7px  }
    30%  { left: 52px  }
    60%  { left: 22px  }
    100% { left: 100px }
}
</style>